import useTable from '@/hooks/useTable';
import { ErrorBlock, LoadingBlock } from '@/components/feature/SectionState';
import SponsorSlot from '@/components/feature/SponsorSlot';
import type { GsPro } from '@/lib/types';
import { proSeries } from '@/mocks/home';

export default function ProCollective() {
  const { data: pros, loading, error, reload } = useTable<GsPro>('gs_pros');

  return (
    <section id="pros" className="bg-background-50 px-4 md:px-8 py-16 md:py-24 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <p className="font-label uppercase tracking-[0.28em] text-xs text-primary-600 font-semibold">Pros</p>
        <h2 className="font-heading font-bold text-4xl md:text-6xl text-foreground-950 leading-[1.02] mt-3">The Pro Collective</h2>
        <p className="mt-5 text-foreground-700 text-base md:text-lg">Local golf professionals helping you play smarter on the courses you actually play.</p>
        <div className="mt-8">
          <SponsorSlot label="Lessons presented by" />
        </div>
        <div className="mt-6 flex flex-wrap gap-2">
          {proSeries.map((s) => (
            <span key={s} className="bg-secondary-100 text-secondary-900 border border-secondary-200 font-label font-semibold uppercase text-sm tracking-wide px-3 py-1.5 rounded-full whitespace-nowrap">{s}</span>
          ))}
        </div>
      </div>
      <div className="lg:col-span-7">
        {loading && <LoadingBlock label="Loading pros" />}
        {error && <ErrorBlock message={error} onRetry={reload} />}
        {!loading && !error && (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {pros.map((p) => (
              <article key={p.id} className="bg-background-100 rounded-lg overflow-hidden border border-background-200">
                <div className="w-full h-80">
                  <img src={p.image} alt={p.name} title={`${p.name}, golf professional`} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-5 border-t-4 border-primary-500">
                  <h3 className="font-heading font-bold text-2xl text-foreground-950">{p.name}</h3>
                  <p className="text-sm text-foreground-600 mt-1">{p.role}</p>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}